import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const BarGraphIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			d="M5.25 7a.75.75 0 0 0-.75.75v3.5a.75.75 0 0 0 1.5 0v-3.5A.75.75 0 0 0 5.25 7M8 2.75a.75.75 0 0 1 1.5 0v8.5a.75.75 0 0 1-1.5 0zM12.25 4a.75.75 0 0 0-.75.75v6.5a.75.75 0 0 0 1.5 0v-6.5a.75.75 0 0 0-.75-.75"
		></path>
		<path
			fill="currentColor"
			d="M3.75 13.5H14a.75.75 0 0 1 0 1.5H3.75A2.75 2.75 0 0 1 1 12.25V2a.75.75 0 0 1 1.5 0v10.25c0 .69.56 1.25 1.25 1.25"
		></path>
	</svg>
))
